import { OcppEvent } from "@/domain/entities";
import moment from "moment";

export class ActivityLog {
  datetime: string;
  action: string;
  summary: string;
  payload?: any;
  show_payload?: boolean = false;
  charge_session_id: number | null;
  connector_id: string | null;
  status: string | null;
  charged_amount: number | null;
  battery_perc: number | null;

  constructor(data: OcppEvent) {
    this.payload = JSON.parse(data.payload);
    this.datetime = moment(data.created_at).format("DD/MM/YYYY HH:mm:ss");
    this.action = data.action;
    this.charge_session_id = data.charge_session_id;
    this.connector_id = data.connector_id;
    this.status = data.status;
    this.charged_amount = data.charged_amount;
    this.battery_perc = data.battery_perc;

    // Build summary
    const summaryParts: string[] = [];

    if (data.status) summaryParts.push(`Status: ${data.status}`);
    if (data.connector_id) summaryParts.push(`Conector: ${data.connector_id}`);
    if (data.charged_amount !== null)
      summaryParts.push(`Carregado: ${data.charged_amount} kWh`);
    if (data.battery_perc !== null)
      summaryParts.push(`Bateria: ${data.battery_perc}%`);

    // Check payload for additional info
    if (this.payload?.meter_read)
      summaryParts.push(`Medidor: ${this.payload.meter_read}`);
    if (this.payload?.charge_speed)
      summaryParts.push(`Velocidade: ${this.payload.charge_speed} kW`);
    if (data.charge_session_id)
      summaryParts.push(`Sessão: #${data.charge_session_id}`);

    this.summary = summaryParts.length > 0 ? summaryParts.join(" | ") : "---";
  }
}
